import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { isLoading, isNormal, isError } from 'resift';
import usePrevious from '@sift/resift/usePrevious';

interface Props {
  status: number;
  message?: string;
  errorMessage?: string;
  variant?: 'error' | 'warning' | 'info' | 'success' | 'default';
}

function showSnackbar({
  status,
  message = 'Action complete.',
  errorMessage = 'An error occurred',
  variant,
}: Props) {
  const previousStatus = usePrevious(status);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (isNormal(status) && isLoading(previousStatus) && !isLoading(status) && !isError(status)) {
      enqueueSnackbar(message, { variant });
    } else if (isError(status) && isLoading(previousStatus) && !isLoading(status)) {
      enqueueSnackbar(errorMessage, { variant: 'error' });
    }
  }, [status, previousStatus]);
}

export default showSnackbar;
